import PropTypes from 'prop-types';
import { Calendar, Clock, Users, ChevronRight } from 'lucide-react';
import { Text, Stack } from '@/components/ui/index.js';
import styles from './EventList.module.css';

/**
 * EventList - List of upcoming events at the venue
 */
export function EventList({ events, onEventClick }) {
  if (events.length === 0) {
    return (
      <div className={styles.empty}>
        <Text color="muted">No upcoming events at this venue</Text>
      </div>
    );
  }
  
  return (
    <div className={styles.list}>
      {events.map((event, index) => (
        <EventCard 
          key={event.id}
          event={event}
          onClick={() => onEventClick(event.id)}
          index={index}
        />
      ))}
    </div>
  );
}

/**
 * Individual event card
 */
function EventCard({ event, onClick, index }) {
  const isLowSpots = event.spotsLeft <= 3;
  
  return (
    <button 
      onClick={onClick}
      className={styles.card}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className={styles.content}>
        <Stack direction="column" gap={2} align="flex-start">
          <Text weight="semibold" color="primary" className={styles.title}>
            {event.title}
          </Text>
          
          <div className={styles.details}>
            <div className={styles.detail}>
              <Calendar size={14} />
              <Text size="sm" color="secondary">{event.date}</Text>
            </div>
            
            <div className={styles.detail}>
              <Clock size={14} />
              <Text size="sm" color="secondary">{event.time}</Text>
            </div>
          </div>
        </Stack>
        
        <div className={styles.footer}>
          <div className={`${styles.spots} ${isLowSpots ? styles.lowSpots : ''}`}>
            <Users size={14} />
            <Text size="sm" weight={isLowSpots ? 'semibold' : 'normal'}>
              {event.spotsLeft} {event.spotsLeft === 1 ? 'spot' : 'spots'} left
            </Text>
          </div>
          
          <ChevronRight size={18} className={styles.arrow} />
        </div>
      </div>
    </button>
  );
}

EventList.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
      spotsLeft: PropTypes.number.isRequired,
    })
  ).isRequired,
  onEventClick: PropTypes.func.isRequired,
};

EventCard.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    spotsLeft: PropTypes.number.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default EventList;
